import { GENERATE_URL } from "@services/helpers/request";

export const Create = (options) =>
  GENERATE_URL(`/Tag/:tagId/Rules`, options);

export const GetByTagId = (options) =>
  GENERATE_URL(`/Tag/:tagId/Rules`, options);

export const Update = (options) => GENERATE_URL(`/TagRule/:id`, options);

export const Delete = (options) => GENERATE_URL(`/TagRule/:id`, options);

export default {
  Create,
  GetByTagId,
  Update,
  Delete,
};
